module.exports = __webpack_public_path__ + "img/no-products.74e5766c.svg";